<template>
    <div >
        <el-button v-if="componentName!='frontedit'" @click="componentName='frontedit'">在页面编辑</el-button>
        <!-- <component :is="componentName" @switchcomponent="switchcomponent" class="main-content"></component> -->
        <frontedit @switchcomponent="switchcomponent" v-if="componentName == 'frontedit'"></frontedit>
        <defineddb v-if="componentName == 'defineddb'" :editpage="true"></defineddb>
        <existingdb v-if="componentName == 'existingdb'" :editpage="true"></existingdb>
    </div>
</template>

<script>
import frontedit from "./frontedit"
// import editfromexcel from "./editfromexcel"
import defineddb from "@/components/exceltodb/defineddb"
import existingdb from "@/components/exceltodb/existingdb"
export default {
    components: { frontedit, defineddb, existingdb },
    data() {
        return {
            componentName: "frontedit"
        }
    },
    computed: {

    },
    methods: {
        switchcomponent(scene) {
            switch (scene) {
                case "dbset":
                    this.componentName = "defineddb"
                    break;
                case "excelupdate":
                    this.componentName = "existingdb"
                    break;
                case "pageedit":
                    this.componentName = "frontedit"
            }
            // if(this.componentName==="frontedit"){
            //     this.componentName="editfromexcel"
            // }
            // else{
            //     this.componentName="frontedit"
            // }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/edit/edit.vue